import "./App.css";
import "./index.css";
import React, { useEffect } from "react";
import axios from "axios";
import { getPortalNamespace, getAuthKey } from "./utils/auth";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/superAdmin/dashboard/Header";
import Footer from "./components/superAdmin/footer/Footer";
import Default from "./routes/Default";
import { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import ExhibitorDashboardNavbar from "./components/exhibitor/exhibitor_dashboard/ExhibitorDashboardNavbar";
import VisitorForm from "./components/HtmlMainPage/MainPage";
import InvitedVIPGuestList from "./components/exhibitor/SubAdminArea/InvitedVIPGuestList";
import AdminInvitedVIPGuestList from "./components/AdminVIP/AdminInvitedVIPGuestList";
import MainRoute from "./routes/MainRoute";
import SuperAdminAreaLogin from "./components/superAdmin/Settings/SuperAdminAreaLogin";
import AdminVIPLogin from "./components/AdminVIP/AdminVIPLogin";
import ExhibitorLogin from "./components/exhibitor/Form/ExhibitorLogin";
import ExhibitorStaff from "./components/visitorform/ExhibitorStaff";
import ExhibitorVip from "./components/visitorform/ExhibitorVip";
import ExhibitorOwner from "./components/visitorform/ExhibitorOwner";
import VendorOwner from "./components/visitorform/VendorOwner";
import VendorStaff from "./components/visitorform/VendorStaff";
import Wrong404 from "./404/Wrong404";
import FrontEndPage from "./components/HtmlMainPage/FrontPage";
import HospitalityLogin from "./components/Hospitality/HospitalityLogin";
import CabServiceLogin from "./components/CabService/CarServiceLogin";
import FlightServicelogin from "./components/FlightService/FlightServiceLogin";
// import BuyerRegistration from "./components/HtmlMainPage/BuyerRegistration";
import KceVisitorRegistration from "./components/HtmlMainPage/KceVisitorRegistration";
import KcePaymentStatus from "./components/HtmlMainPage/KcePaymentStatus";
import SuccessFullPage from "./components/HtmlMainPage/SuccessFullPage";
import FailPage from "./components/HtmlMainPage/FailPage";
import PaymentComponent from "./components/HtmlMainPage/PaymentComponent";
import BuyerAdminLogin from "./components/BuyerAdmin/BuyerAdminLogin";
import VisitorAdminLogin from "./components/visitorAdmin/VisitorAdminLogin";
import UploadPhoto from "./components/superAdmin/Settings/UploadPhoto";
import CabManagementLogin from './components/CabManagement/login.js';
import HotelManagementLogin from './components/HotelManagement/login.js';
function App() {
  useEffect(() => {
    // Axios Interceptor to manage portal-specific tokens
    const interceptor = axios.interceptors.request.use(
      (config) => {
        // If the token is already explicitly provided (except if it's "null" or "undefined" as string from localStorage)
        const explicitToken = config.headers.token;

        if (!explicitToken || explicitToken === "null" || explicitToken === "undefined" || explicitToken === null) {
          const namespace = getPortalNamespace(window.location.pathname);
          if (namespace) {
            const tokenKey = getAuthKey("token", namespace);
            const token = localStorage.getItem(tokenKey);
            if (token) {
              config.headers.token = token;
            }
          }
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(interceptor);
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data.data && res.data.data.favicon) {
          const favicon = res.data.data.favicon;
          const faviconUrl = `${process.env.REACT_APP_IMAGE_URL}/branding/${favicon}`;

          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = faviconUrl;
        }
      })
      .catch((err) => console.log("Failed to fetch favicon:", err));
  }, []);

  return (
    <>
      {/* <Suspense fallback={<Spinner animation="border" size="lg" />}> */}
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center content-height">
            Loading... &nbsp; &nbsp;
            <Spinner animation="border" size="lg" />
          </div>
        }
      >
        <Routes>
          <Route path="/adminvip/login" element={<AdminVIPLogin />} />
          <Route path="/superadmin/login" element={<SuperAdminAreaLogin />} />
          <Route path="/subadmin/login" element={<SuperAdminAreaLogin />} />
          <Route path="/exhibitor/login" element={<ExhibitorLogin />} />
          {/* <Route path="/hospitality/login" element={<HospitalityLogin />} />
          <Route path="/cab-service/login" element={<CabServiceLogin />} /> */}
          <Route path="/buyer-admin/login" element={<BuyerAdminLogin />} />
          <Route path="/visitor-admin/login" element={<VisitorAdminLogin />} />
          <Route path="/agent/login" element={<ExhibitorLogin />} />
          <Route path="/associate/login" element={<ExhibitorLogin />} />
          <Route path="/sponser/login" element={<ExhibitorLogin />} />
          <Route path="/hotelmanagement/login" element={<HotelManagementLogin/>} />
          <Route path="/cabmanagement/login" element={<CabManagementLogin/>} />

          <Route
            path="/flight-service/login"
            element={<FlightServicelogin />}
          />
          <Route path="/404" element={<Wrong404 />} />
          <Route path="/" element={<FrontEndPage />} />
          {/* <Route
            path="/exhibitor-staff-registration"
            element={<ExhibitorStaff />}
          /> */}
          <Route path="/registration" element={<VisitorForm />} />
          <Route path="/payment-successful" element={<SuccessFullPage />} />
          <Route path="/payment" element={<PaymentComponent />} />

          <Route path="/payment-failed" element={<FailPage />} />

          <Route
            path="/kce-visitor-registration"
            element={<KceVisitorRegistration />}
          />
          <Route
            path="/kce-payment-status"
            element={<KcePaymentStatus />}
          />

          <Route
            path="/uploadPhoto"
            element={<UploadPhoto />}
          />

          {/* <Route
            path="/exhibitor-vip-registration"
            element={<ExhibitorVip />}
          /> */}
          {/* <Route
            path="/exhibitor-owner-registration"
            element={<ExhibitorOwner />}
          /> */}
          <Route
            path="/vendor-owner-registration/:barcode"
            element={<VendorOwner />}
          />
          <Route
            path="/vendor-staff-registration/:barcode"
            element={<VendorStaff />}
          />
          <Route path="/vip-guest-registration" element={<ExhibitorVip />} />
          {/* <Route path="/buyer-registration" element={<BuyerRegistration />} /> */}
          <Route path="/404" element={<Wrong404 />} />
          <Route path="*" element={<Default />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
